"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eobStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
class EobStore {
    constructor() {
        this.loadBalanceFailed = false;
        this.eobs = {
            loading: false,
            value: [],
        };
        this.showHistory = true;
        this.eobSelected = null;
        this.CheckSubmissionFailed = "";
        this.showLoader = false;
        this.showPayback = false;
        //   /** Query Actions */
        this.loadLedgerBalance = async (query) => {
            const { siteId } = query;
            const setFlag = 0;
            const result = await api_1.LedgerEndpoint.loadbalance.apiCall({ query });
            if (api_1.isError(result)) {
                this.showLoader = false;
                if (result.code === "NOT_FOUND") {
                    this.loadBalanceFailed = true;
                    alert("Updating ledger balance for selected site. Please try again in a few minutes.");
                }
                else {
                    await api_1.LedgerEndpoint.updateLedgerFlag.apiCall(null, {
                        siteId,
                        setFlag,
                    });
                    alert("error in loading ledger balance ");
                }
                // console.log("result", result);
            }
            else {
                this.showLoader = false;
                this.ledgerBalance = result.balance;
                this.ledgerEntryId = result.ledgerId;
            }
        };
        this.updateLedgerFlag = async (siteId, setFlag) => {
            // console.log("object ====", { siteId, setFlag });
            const result = await api_1.LedgerEndpoint.updateLedgerFlag.apiCall(null, {
                siteId,
                setFlag,
            });
            // console.log("result---------------->", result);
            if (api_1.isError(result)) {
                alert("error in updating ledger flag ");
                // console.log("result", result);
            }
        };
        this.loadClaims = async (query = {
            count: 200,
            start: 0,
        }, showLoading = false) => {
            const result = await api_1.EobEndpoint.loadclaims.apiCall({ query });
            // console.log("result---------------->", result);
            if (api_1.isError(result)) {
                alert("error in loading claims ");
                // console.log("result", result);
            }
            else {
                this.claims = result.claims;
            }
        };
        // @action
        // public loadClaims = async (query: {
        //   [key: string]: number;
        //   siteId: number;
        // }) => {
        //   const result = await EobEndpoint.loadclaims.apiCall({ query });
        //   // console.log("result---------------->", result);
        //   if (isError(result)) {
        //     alert("error in loading claims ");
        //     // console.log("result", result);
        //   } else {
        //     this.claims = result.claims;
        //   }
        // };
        this.loadPayers = async () => {
            const result = await api_1.EobEndpoint.loadpayers.apiCall();
            // console.log("result---------------->", result);
            if (api_1.isError(result)) {
                alert("error in loading payers ");
                // console.log("result", result);
            }
            else {
                this.payers = result.payers;
            }
        };
        this.insertHeader = async (eobHeader, userId, siteId) => {
            const result = await api_1.EobEndpoint.insertheader.apiCall(null, {
                eobHeader,
                userId,
                siteId,
            });
            if (api_1.isError(result)) {
                alert("error in inserting header");
            }
            else {
                return result.headerId;
            }
        };
        this.loadEob = async (query) => {
            // console.log("query passed into loadEob is", query);
            const result = await api_1.EobEndpoint.loadeob.apiCall({ query });
            // console.log("result from loadEob is ", result);
            if (api_1.isError(result)) {
                alert("error in loading eob");
            }
            else {
                this.eob = result.eob;
            }
        };
        // E-067
        this.readEob = async (query) => {
            const result = await api_1.EobEndpoint.eobread.apiCall({ query });
            if (result) {
                return result;
            }
            if (api_1.isError(result)) {
                this.eobData = {
                    error: result.code,
                    status: false,
                };
            }
        };
        this.loadEobs = async (query) => {
            const result = await api_1.EobEndpoint.loadeobs.apiCall({ query });
            this.eobs.loading = true;
            // console.log("result from loadEobs is ", result);
            if (api_1.isError(result)) {
                alert("error in loading eobs");
            }
            else {
                this.eobs = Object.assign(Object.assign({}, this.eobs), { value: result.eobs, loading: false });
                // console.log("this.eobs ====>", this.eobs);
            }
        };
        this.updateHeader = async (headerId, eobTotal) => {
            const result = await api_1.EobEndpoint.updateheader.apiCall(null, {
                headerId,
                eobTotal,
            });
            if (api_1.isError(result)) {
                return false;
            }
            return result;
        };
        this.insertDetail = async (claimEobDetail, headerId, userId, payerName) => {
            const result = await api_1.EobEndpoint.insertdetail.apiCall(null, {
                claimEobDetail,
                headerId,
                userId,
                payerName,
            });
            if (api_1.isError(result)) {
                return false;
            }
            return result;
        };
        this.updatePayer = async (claimEobDetail, payerName, eobSiteId) => {
            const result = await api_1.EobEndpoint.updatepayer.apiCall(null, {
                claimEobDetail,
                payerName,
                eobSiteId,
            });
            if (api_1.isError(result)) {
                return false;
            }
            return result;
        };
        this.insertLedger = async (claimEobDetail, eobHeader, headerId, eobSiteId, siteImbFee, currentUserId) => {
            const result = await api_1.LedgerEndpoint.insertfeesledger.apiCall(null, {
                claimEobDetail,
                eobHeader,
                headerId,
                eobSiteId,
                siteImbFee,
                currentUserId,
            });
            if (api_1.isError(result)) {
                return false;
            }
            return result;
        };
        this.insertChecksLedger = async (checksArray, 
        // eobSiteId: number,
        // pharmacyName: string,
        // balance: number,
        // checkAmount: number,
        // checkDate: Date,
        // checkNumber: string,
        currentUserId, endDate, startDate, fundType) => {
            this.CheckSubmissionFailed = "";
            const result = await api_1.LedgerEndpoint.insertChecksLedger.apiCall(null, {
                checksArray,
                // eobSiteId,
                // pharmacyName,
                // balance,
                // checkAmount,
                // checkDate,
                // checkNumber,
                currentUserId,
                endDate,
                startDate,
                fundType,
            });
            if (api_1.isError(result)) {
                if (result.code === "NOT_FOUND") {
                    // console.log("not found code in insert checks store");
                    return false;
                }
                this.CheckSubmissionFailed = result.code;
                // console.log(
                //   "error in insert function with result code: ",
                //   this.CheckSubmissionFailed
                // );
                return true;
                // return false;
            }
            return true;
        };
    }
}
__decorate([
    mobx_1.observable
], EobStore.prototype, "claims", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "payers", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "ledgerBalance", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "ledgerEntryId", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "loadBalanceFailed", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "eob", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "eobs", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "showHistory", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "eobSelected", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "CheckSubmissionFailed", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "showLoader", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "showPayback", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "selectedRowsPayback", void 0);
__decorate([
    mobx_1.observable
], EobStore.prototype, "eobData", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "loadLedgerBalance", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "updateLedgerFlag", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "loadClaims", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "loadPayers", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "insertHeader", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "loadEob", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "readEob", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "loadEobs", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "updateHeader", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "insertDetail", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "updatePayer", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "insertLedger", void 0);
__decorate([
    mobx_1.action
], EobStore.prototype, "insertChecksLedger", void 0);
exports.eobStore = new EobStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/eob/store.ts
// module id = 514
// module chunks = 0